export enum MailStatus {
  Reply = 13,
  ChannelIntroduction = 31,
  Introduction = 14,
  PostConversionComplaint = 46,
  BadFitNoReference = 47
}
